export default __webpack_public_path__ + "static/media/nearExampleImg.86052d2c.jpg";